import axios from '../http'
import global from '@/constants/Global.constants'

export default {
  getProductAllType (params) {
    return axios.post(global.PMC_INFO + '/type/findAllProductType', params)
  },
  getProductTradeMark (params) {
    return axios.post(global.PMC_INFO + '/trademark/findAllProductTradeMark', params)
  },
  getDesigner (params) {
    return axios.post(global.PMC_INFO + '/designer/findPmcProductDesigner', params)
  },
  getAttrByProductTypeId (params) {
    return axios.post(global.PMC_INFO + '/attribute/findAttributeByProductTypeId', params)
  },
  updateProductUpDownRacks (params) {
    return axios.post(global.PMC_INFO + '/product/updateProductUpDownRacks', params)
  },
  updateProductSetNewProduct (params) {
    return axios.post(global.PMC_INFO + '/product/updateProductSetNewProduct', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/pmc/product.js